﻿import { formatToTwoDecimals } from '../utils/currencyUtils.js';

export function getUsageRatio(remaining, total) {
    let result;

    if (total === 0) {
        result = 1;
    } else {
        result = ((total - remaining) / total);
    }
    return result;
}

export function getPlanByCode(plansData, code) {
    let result;
    result = plansData.find(plan => plan.code === code);
    return result;
}

export function getPlanClassNameByCode(planCode) {
    switch (planCode) {
        case "BSN":
            return 'business';
        case "STD":
            return 'standard';
        case "BSC":
            return 'basic';
        case "FRE":
            return 'free';
        default:
            return null;
    }
}

export function returnConvertions(planData) {
    const self = this;
    let conversionsValue = planData.conversions;
    return conversionsValue;
}

export function returnPlansConfig(planData) {
    function createPoint(text) {
        if (text.includes('call')) {
            return `<div><i class="fa-solid fa-phone plan__points__icon me-1"></i> ${text.replace('call', '')}</div>`;
        }
        return `<div><i class="fa-solid fa-circle-check me-1 plan__points__icon"></i> ${text}</div>`;
    }

    function generatePoints(points) {
        return `<div>${points.map(point => createPoint(point)).join('')}</div>`;
    }

    const plans = {
        FRE: {
            name: 'free',
            icon: `<i class="fa-solid fa-chess-pawn"></i>`,
            title: 'Free',
            description: 'To try Declarator',
            points: [
                `Up to ${returnConvertions(planData)} uploads monthly`,
                'Batch upload'
            ]
        },
        BSC: {
            name: 'basic',
            icon: `<i class="fa-solid fa-chess-bishop"></i>`,
            title: 'Basic',
            description: 'Ideal for smaller workflows',
            points: [
                `Up to ${returnConvertions(planData)} uploads monthly`,
                'Batch upload',
                'No personal data stored',
                'Online/email support',
                'Walrus branding'
            ]
        },
        STD: {
            name: 'standard',
            icon: `<i class="fa-solid fa-chess-rook"></i>`,
            title: 'Standard',
            description: 'Optimized for expanding operations',
            points: [
                `Up to ${returnConvertions(planData)} uploads monthly`,
                'Batch upload',
                'No personal data stored',
                'Online/email support',
                'Walrus branding'
            ]
        },
        BSN: {
            name: 'business',
            icon: `<i class="fa-solid fa-chess-queen"></i>`,
            title: 'Business',
            description: 'Tailored for high-demand loads',
            points: [
                `Up to ${returnConvertions(planData)} uploads monthly`,
                'Batch upload',
                'No personal data stored',
                'Online/email support',
                'call Walrus branding',
                'call Own branding/logo',
                'call Personal agreement',
                'call API integration'
            ]
        }
    };
    const selectedPlan = plans[planData.code];

    return {
        ...selectedPlan,
        points: generatePoints(selectedPlan.points)
    };
    
};

export function getPlanPrice(plandata, selectedBillingRecurrency, showSale) {

    let periodPrice;
    switch (selectedBillingRecurrency.toLowerCase()) {
        case 'month':
            periodPrice = showSale ? plandata.monthDiscountPrice : plandata.monthPrice;
            break;
        case 'year':
            periodPrice = showSale ? plandata.yearDiscountPrice : plandata.yearPrice;
            break;
        default:
            periodPrice = 0;
            break;
    }
    periodPrice = formatToTwoDecimals(periodPrice);
    return periodPrice;
}
export function checkIfFreePlanByCode(code) {
    let result = false;
    if (code === "FRE") {
        return result = true;
    }
    return result;
}